import { z } from "zod";

import { subYears } from "date-fns";

export const employeeRecordSchemaFactory = () => {
    const now = Date.now();
    const minDateOfBirth = subYears(now, 100);
    const maxDateOfBirth = subYears(now, 13);
    const schema = z.object({
        id: z.string().nullish(),
        title: z.string().min(1, { message: "Title is required" }).max(25, { message: "Maximum of 25 characters only" }),
        firstName: z.string().min(1, { message: "First Name is required" }),
        lastName: z.string().min(1, { message: "Last Name is required" }),
        previousLastName: z.string().nullable(),
        gender: z.string().optional(),
        personalEmailAddress: z.string().nullable(),
        workEmailAddress: z.string().nullable(),
        homePhoneNumber: z.string().nullable(),
        workPhoneNumber: z.string().nullable(),
        mobilePhoneNumber: z.string().nullable(),
        addressLine1: z.string().nullable(),
        addressLine2: z.string().nullable(),
        addressLine3: z.string().nullable(),
        city: z.string().nullable(),
        county: z.string().nullable(),
        postCode: z.string().nullable(),
        jobTitle: z.string().nullable(),
        secondaryReference: z.string().max(20).optional(),
        criticalNotes: z.string().nullable(),
        terminationDate: z.preprocess(
            v => v || null,
            z.coerce.date()
                .nullable()
        ),
        active: z.boolean().optional(),
        customerId: z.string(),
        customerName: z.string().nullable(),
        orgStructureOne: z.object({ name: z.string(), id: z.string() }, { required_error: "Organisation Level One is required" }),
        orgStructureTwo: z.object({ name: z.string(), id: z.string() }).nullish(),
        orgStructureThree: z.object({ name: z.string(), id: z.string() }).nullish(),
        orgStructureFour: z.object({ name: z.string(), id: z.string() }).nullish(),
        workGroups: z.array(z.object({ name: z.string(), id: z.string() })).optional(),
        personalReferenceNumber: z.string().nullish(),
        legacyPersonalId: z.string().nullish(),
        dateOfBirth: z.preprocess(
            v => v || null,
            z.coerce.date()
                .min(minDateOfBirth, { message: "Please check Date of Birth. Age should be between 13 and 100 years." })
                .max(maxDateOfBirth, { message: "Please check Date of Birth. Age should be between 13 and 100 years." })
                .nullable()
        ),
    }).refine(form =>
        !form.secondaryReference && !form.dateOfBirth ? false : true, { message: "Date of Birth is required", path: ["dateOfBirth"] });

    return schema;
};

export type EmployeeRecordFormModel = z.infer<ReturnType<typeof employeeRecordSchemaFactory>>;
